import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'network-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
